module.exports = __webpack_public_path__ + "static/media/diseno-logo-bogota.3408b461.jpg";